import React, { ReactNode } from "react";
import { QA_LABELS } from "../../utils/constants";
import Body from "../Body";
import Footer from "../Footer";

export interface Props {
  actions: ReactNode[];
  details: ReactNode;
}

const WelcomeModal = ({ actions, details }: Props) => (
  <div data-qa-label={QA_LABELS.WELCOME_MODAL}>
    <Body>{details}</Body>
    <Footer>{actions}</Footer>
  </div>
);
export default WelcomeModal;
